document.addEventListener('DOMContentLoaded', () => {
    // Accordion handling
    let togglers = document.querySelectorAll('.location-group-reader__location-toggler');
    let markers = document.querySelectorAll('.location-group-reader__zoom-marker');
    let locations = document.querySelectorAll('.location-group-reader__location');

    if (togglers) {
        togglers.forEach((toggler) => {
            toggler.addEventListener('click', () => {
                if (toggler.classList.contains('open')) {
                    toggler.classList.toggle('open');
                } else {
                    togglers.forEach((toggler) => {
                        toggler.classList.remove('open');
                    });
                    toggler.classList.toggle('open');
                }
            });
        });
    }

    // Map handling
    if (markers && locations) {
        markers.forEach((marker) => {
            marker.addEventListener('click', () => {
                // Handle marker
                markers.forEach((marker) => {
                    marker.classList.remove('active');
                });
                marker.classList.add('active');

                // Handle location
                let alias = marker.dataset.markerAlias;
                if (alias) {
                    let location = document.querySelector('.location-group-reader__location[data-location-alias="' + alias + '"]');
                    if (location) {
                        locations.forEach((location) => {
                            location.classList.remove('active');
                        });
                        location.classList.add('active');
                    }
                }
            });
        });
    }

    // Activate pulse animation
    let pins = document.querySelectorAll('.location-group-reader__zoom-marker:not(.active)');
    let delay = 4500;

    pulsePins(delay);
    setInterval(() => {
        pulsePins(delay);
    }, pins.length * delay);

    function pulsePins(delay) {
        let pins = document.querySelectorAll('.location-group-reader__zoom-marker:not(.active)');
        pins.forEach((pin, index) => {
            setTimeout(() => {
                // Add class
                pin.classList.add('pulse');

                // Remove class
                setTimeout(() => {
                    pin.classList.remove('pulse');
                }, 1750);
            }, index * delay);
        });
    }
});